import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const RolesAndPermissionConfigContext = createContext(null);

type Props = {
  children: ReactElement;
};

const RolesAndPermissionConfigProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put("settings/roles", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <RolesAndPermissionConfigContext.Provider value={contextValue}>
      {children}
    </RolesAndPermissionConfigContext.Provider>
  );
};

export default RolesAndPermissionConfigProvider;
